<template>
  <div>
    <HeaderComponent :menu-id="2"></HeaderComponent>
    <div style="background-color: #FFFFFF;">
      <div class="peifu-container" style="width: 1200px;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>古钱币送评</span>收费标准</div>
        </div>
        <!-- <div class="shoufei-title">古钱币评级</div>
        <div class="table-box">
          <table>
            <thead>
              <tr>
                <th>市场估值</th>
                <th>评级费</th>
                <th>版别费</th>
                <th>X光</th>
                <th>定向估值<br>全额赔付</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1000元以下<br>(不含1000元)</td>
                <td>80元(基础费用)</td>
                <td>标版收费20元/枚</td>
                <td>有</td>
                <td>无</td>
              </tr>
              <tr>
                <td>1000元-10万元<br>(不含10万元)</td>
                <td>80元(基础费用)+估值2%</td>
                <td>标版收费20元/枚</td>
                <td>有</td>
                <td>有</td>
              </tr>
              <tr>
                <td>10万元及以上</td>
                <td>估值2.5%</td>
                <td>标版收费20元/枚</td>
                <td>有</td>
                <td>有</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5">
                  <div style="color: #DBB052; font-size: 18px;">-&nbsp;&nbsp;&nbsp;关于定向估值全额赔付的注释:</div>
                  <div style="color: #fff; font-size: 16px;">-&nbsp;&nbsp;&nbsp;定向估值是指一币一估值，对估值不再范围化。按估值进行全额赔付，不因行情或市场价值的变化而改变赔付金额的多少。</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="shoufei-title">批量评级</div>
        <div class="table-box">
          <table>
            <thead>
              <tr>
                <th>市场估值</th>
                <th>数量</th>
                <th>评级费</th>
                <th>时效(工作日)</th>
                <th>包装方式</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>500元以内<br>(含500元)</td>
                <td>20枚(同一品种)</td>
                <td>30元</td>
                <td>10天</td>
                <td>开放式水晶盒</td>
                <td>不含异形币<br>无X光图<br>只标常见版别</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" style="padding-left: 50px;">
                  <div style="color: #fff; font-size: 16px;">-&nbsp;&nbsp;&nbsp;注:批量评级需同钱局，同背文;批量价格固定,不参与任何折扣活动</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="shoufei-title">换盒</div>
        <div class="table-box">
          <table>
            <thead>
              <tr>
                <th>消费名称</th>
                <th>明细</th>
                <th>费用</th>
                <th>备注</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>换盒子费用</td>
                <td>锦盒(含手写签)<br>水晶盒<br>纸夹(含手写签)</td>
                <td>30元<br>15元<br>15元</td>
                <td>更换盒子需将原包装及钱币寄回更换</td>
              </tr>
              <tr>
                <td>定制盒费用</td>
                <td>圆形币<br>异形币</td>
                <td>150元<br>180元</td>
                <td>钱币在本公司才可咨询是否可以定制</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5">
                  <div style="color: #fff; font-size: 16px;">-&nbsp;&nbsp;&nbsp;注:盒子费用固定,不叠加其它优惠使用</div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div> -->

        <img src="@/assets/image/shoufei-guqian.jpg" alt="" style="width: 1200px; margin: 0 auto 60px auto;" />

        <div class="shoufei-title">估值提升</div>
        <div class="shoufei-4">
          <div style="width: 40%;"><span>服务名称</span>估值提升</div>
          <div><span>费用</span>基础服务费60元+估值提升部分*2%</div>
          <img src="@/assets/icon/sheng.png" alt="">
        </div>
        <!-- 附件 -->
        <ul class="fu-list">
          <li class="fu-item" v-for="item in fuList">{{ item }}</li>
        </ul>
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      fuList: [
        '附1:鉴定结果为伪品的钱币，按照真币估值正常收取评级费。',
        '附2:鉴定为03、04、05的钱币，如送评人有主观意识，并要求评03、04、05，应以其问题币的价值进行评估收费。反之，送评人非主观意识的问题币送评，应以其正常钱币的价值进行估值正常收费，且不标注估值。',
        '附3:鉴定结果为"无法判断"返还钱币，不收取鉴定费用。',
        '附4:快评费用标准:快评服务费用为普通评级费用的2倍(可参与正常折扣)。5个工作日时效定义:指送评藏品签收后，小程序端5个工作日内出具评级结果。',
        '附5:版别标注以专业著述为依据，未获得公认的版别和名称不标注。',
        '附6:直径小于18.6mm或大于64.5mm，厚度超过6mm无法封装的古钱币，只出具评级标签或吊牌。',
        '附7:低值批量采用水晶封闭盒进行封装，具体收费标准请联系客服。',
        '附8:木盒封装需额外收取小盒100元/个，中盒150元/个的木盒费用。',
        '附9:定制盒具体费用请联系客服。'
      ]
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.shoufei-title{
  font-size: 28px;
  font-weight: bold;
  color: #907B47;
  margin-bottom: 20px;
  letter-spacing: 2px;
}
.shoufei-4{
  display: flex;
  align-items: center;
  border: 1px solid #DDAF58;
  padding: 0 150px 0 50px;
  height: 80px;
  line-height: 78px;
  position: relative;
  div{
    font-size: 16px;
    span{
      font-size: 26px;
      font-weight: bold;
      padding-right: 30px;
    }
  }
  img{
    width: 120px;
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}
.fu-list{
  margin-top: 80px;
}
.fu-item{
  letter-spacing: 1px;
  font-size: 16px;
  margin: 5px 0;
  line-height: 30px;
}
</style>